import React from 'react';
import {
  DollarSign,
  ShoppingBag,
  FileText,
  Briefcase,
  Shield,
  Search
} from 'lucide-react';
import { Button } from './ui/button';
import { practiceAreas } from '../data/mock';
import { useParallaxSimple } from '../hooks/useParallax';

const iconMap = {
  DollarSign,
  ShoppingBag,
  FileText,
  Briefcase,
  Shield,
  Search
};

export const AreasSection = () => {
  const parallaxBlob = useParallaxSimple(0.09);
  const parallaxBlobAlt = useParallaxSimple(-0.055);

  const scrollToForm = () => {
    const element = document.querySelector('#analise');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="areas" className="py-16 sm:py-20 lg:py-24 bg-white relative overflow-hidden">
      <div
        className="absolute top-1/4 -right-24 w-64 h-64 sm:w-[22rem] sm:h-[22rem] rounded-full bg-[#d4af37]/7 blur-3xl pointer-events-none"
        style={parallaxBlob.style}
        aria-hidden
      />
      <div
        className="absolute bottom-10 -left-16 w-48 h-48 sm:w-64 sm:h-64 rounded-full bg-[#0f1f3d]/[0.035] blur-3xl pointer-events-none"
        style={parallaxBlobAlt.style}
        aria-hidden
      />

      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-12 sm:mb-14">
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl text-[#0f1f3d] leading-tight mb-3 tracking-tight">
            Áreas de atuação
          </h2>
          <p className="text-slate-500 text-sm sm:text-base leading-relaxed">
            Assessoria jurídica especializada com foco em clareza, estratégia e acompanhamento em todas as etapas.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 mb-12">
          {practiceAreas.map((area) => {
            const Icon = iconMap[area.icon] || FileText;
            return (
              <div
                key={area.id}
                className="p-6 sm:p-7 bg-white rounded-md border border-slate-200 hover:border-[#d4af37]/35 hover:shadow-md transition-all duration-300"
              >
                <Icon className="w-6 h-6 text-[#b8962e] mb-4 stroke-[1.5]" />
                <h3 className="font-serif text-base sm:text-lg text-[#0f1f3d] mb-2 leading-snug font-semibold">
                  {area.title}
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed">
                  {area.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="flex justify-center">
          <Button
            onClick={scrollToForm}
            size="lg"
            className="bg-[#0f1f3d] hover:bg-[#1a2f4d] text-white rounded-md w-full sm:w-auto sm:min-w-[320px] px-10 py-6 text-base font-semibold"
          >
            Quero orientação sobre meu caso
          </Button>
        </div>
      </div>
    </section>
  );
};
